import instance from "../../services/api";

export const fetchContractList = params => {
  return instance(true)
    .post(`/partner/contractor_agreement_list/`, params)
    .then((res = {}) => {
      return res;
    });
};

export const getSpecificationXml = params => {
  return instance(true)
    .post(`/partner/contractor_agreement_list/specification/xml/`, params)
    .then((res = {}) => {
      return res;
    });
};
export const getAccessionXml = body => {
  return instance(true)
    .post(`/partner/contractor_agreement_list/accession_agreement/xml/`, body)
    .then((res = {}) => {
      return res;
    });
};
export const signSpecificationXml = params => {
  return instance(true)
    .post(`/partner/contractor_agreement_list/specification/sign/`, params)
    .then((res = {}) => {
      return res;
    });
};
export const signSpecificationV2 = params => {
  const payload = {
    ...params,
    return_url: window.location.href
  };

  return instance(true)
    .post(`/partner/contractor_agreement_list/specification/sign/v2/`, payload)
    .then((res = {}) => {
      return res;
    });
};

export const getSpecificationSignedDocumentV2 = signId => {
  return instance(true, null, { showToast: false, throwError: true }).get(
    `/partner/contractor_agreement_list/specification/sign/v2/signed/${signId}/`,
    { responseType: "blob" }
  );
};
export const signAccessionXml = params => {
  return instance(true)
    .post(
      `/partner/contractor_agreement_list/accession_agreement/sign/`,
      params
    )
    .then((res = {}) => {
      return res;
    });
};

/** Подписанный файл (PDF/Docx) из sign_message, без NCA. См. legacy_download в ответе v2. */
export const getSpecificationSignedDocumentLegacy = signId => {
  return instance(true, null, { showToast: false, throwError: true }).get(
    `/partner/contractor_agreement_list/signed/${signId}/`,
    { responseType: "blob" }
  );
};

